if (!customElements.get('riot-product-details')) {
  customElements.define('riot-product-details', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const main = document.querySelector('#MainContent product-info');
        if (!data?.variant || data.sectionId !== main?.dataset.section) return;
        this.refresh(data.variant.id);
      });
    }
    async refresh(variantId) {
      this.controller?.abort();
      this.controller = new AbortController();
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('riot-product-details');
        if (updated) this.innerHTML = updated.innerHTML;
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Product information could not refresh.');
      }
    }
    disconnectedCallback() { this.unsubscribe?.(); this.controller?.abort(); }
  });
}
